import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { SimpleButton } from './styles';

interface Props {
  onClick: () => void;
}
const ButtonHelp = ({ onClick }: Props) => {
  const { t } = useStoreTranslation();

  return <SimpleButton onClick={onClick}>{t('payment.paymentMethods.help')}</SimpleButton>;
};

export default ButtonHelp;
